import NextLink from 'next/link';

import { Heading, Image } from '@frontendmentorio/design-system-v2';

export default function Ecologi() {
  return (
    <div className="px-5 py-6">
      <div className="container-xl flex flex-col gap-6 items-center tablet:pb-7 desktop:flex-row desktop:justify-between">
        <div className="aspect-square relative shrink-0 w-[20rem] desktop:w-[26rem]">
          <Image
            alt=""
            className="rounded-xl w-[16rem] desktop:w-[22rem]"
            height={612}
            src="/static/images/pro-ecologi.webp"
            width={674}
          />

          <NextLink
            className="absolute bg-no-repeat bg-[url('/static/images/pro-ecologi-bg.png')] block bottom-0 p-4 right-0 rounded-xl w-max"
            href="https://ecologi.com/frontendmentor?r=5f8c344d7109dc001c37d563"
          >
            <Image
              alt="View our Ecologi profile"
              className="w-[8rem] desktop:w-[10rem]"
              height={160}
              src="https://api.ecologi.com/badges/trees/5f8c344d7109dc001c37d563?black=true&treeOnly=true"
              width={200}
            />
          </NextLink>
        </div>

        <div className="flex flex-col gap-6 items-center max-w-prose text-center desktop:items-start desktop:text-start">
          <Heading level="3" tagName="h2">
            We believe in business for good
          </Heading>

          <p className="text-lg text-neutral-500">
            We strongly believe businesses should use their position to do good
            in the world. For one of our initiatives, we’ve partnered with
            Ecogoli so that for every new and renewed subscription, trees are
            planted. We also fund climate-positive projects.
          </p>
        </div>
      </div>
    </div>
  );
}
